module.exports = __webpack_public_path__ + "static/benbrika-brahim-8479fadbec4db264436130b7eaf0440c.jpg";